// extracted by mini-css-extract-plugin
export var textInput = "_hn-0";